import { Box, Stack, Typography } from '@mui/material';
import { ComponentType } from 'react';

import { BoxedIcon } from '@/components/display/Ribbon/BoxedIcon';
import { IconProps } from '@/components/icons/ChevronDownIcon';
import { COLORS } from '@/styles/tokens/colors';
import { FONT_WEIGHTS } from '@/styles/tokens/fonts';

export interface EmptyStateProps {
  icon: ComponentType<IconProps>;
  text: string;
  variant: 'error' | 'no-results';
}

export function EmptyState({ icon, text, variant }: EmptyStateProps) {
  const borderColor =
    variant === 'error' ? COLORS.ORANGE[200] : COLORS.GRAY[300];
  const iconColor =
    variant === 'error' ? COLORS.FUNCTIONAL.ERROR[700] : COLORS.GRAY[700];
  const iconBackgroundColor =
    variant === 'error' ? COLORS.ORANGE[100] : COLORS.GRAY[100];
  const textColor =
    variant === 'error' ? COLORS.FUNCTIONAL.ERROR[900] : COLORS.TEXT.PRIMARY;

  return (
    <Box
      sx={{
        backgroundColor:
          variant === 'error' ? COLORS.FUNCTIONAL.ERROR[50] : 'white',
        borderRadius: 1,
        border: `solid 1px ${borderColor}`,
        p: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <BoxedIcon
          icon={icon}
          iconProps={{
            size: 24,
            color: iconColor,
          }}
          sx={{
            bgcolor: iconBackgroundColor,
            borderRadius: '8px',
            padding: 1,
          }}
        />
        <Typography
          variant="body-s"
          fontWeight={FONT_WEIGHTS.bold}
          color={textColor}
          textAlign="center"
        >
          {text}
        </Typography>
      </Stack>
    </Box>
  );
}
